import { createSlice } from "@reduxjs/toolkit";

const authReducer = createSlice({
  name: "auth",
  initialState: {
    initialized: false,
  },
  reducers: {},
});
export default authReducer.reducer;
